import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.4.1_@types+node@22.6.1_db0@0.3.1_eslint@9.31.0_jiti@2.4.2__iore_4d2f6wpheq7gpfosezcu5zi3hm/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}